// extracted by mini-css-extract-plugin
export default {"title":"events_title__3RE-X","card_floating_img_cards":"events_card_floating_img_cards__52veK"};